export default __webpack_public_path__ + "static/media/PriskaLovelace.24e79c38.png";